'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEY_PREFIX = exports.KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = exports.REHYDRATE = 'persist/REHYDRATE';


//////////////////
// WEBPACK FOOTER
// ./~/redux-persist/lib/constants.js
// module id = 86
// module chunks = 3